<div class="modal-header">
  <h3 class="modal-title">{{ 'hc.' + action | transloco }}
  </h3>

  <button class="close" type="button" (click)="dismissModal()">
    <span>×</span>
  </button>
</div>

<div class="modal-body">
  <div class="m--margin-top-20">
    <label class="is--required" for="cancelReason">{{ 'storage-invoices-confirm.cause' | transloco }}:</label>

    <textarea id="cancelReason" class="form-control m-input" [(ngModel)]="cancelReason"></textarea>
  </div>

  <div class="text-right m--margin-top-15">
    <button type="button" [disabled]="isLoading.submit" (click)="rejectStorageInvoice()"
            class="hc-button hc-button--danger">
      {{ 'hc.' + action | transloco }}
    </button>

    <button type="button" (click)="dismissModal()" class="hc-button hc-button--secondary">
      {{ 'btn.cancel' | transloco }}
    </button>
  </div>
</div>
